import { render } from "./not_mobile.alert.vue?vue&type=template&id=12c8d533"
import script from "./not_mobile.alert.vue?vue&type=script&lang=js"
export * from "./not_mobile.alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__